/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { createReactRoot } from "common/react/create-react-root";
import { IntlProvider } from "react-intl";
import { messages } from "intl/messages";
import JiffyServicesPreview from "./JiffyServicesPreview.vue";
import "./jiffy-services-preview.scss";

function readPropsFromDom(container: HTMLElement) {
  const el = container.querySelector("jiffy-services-preview");
  if (!el) return {};

  return {
    services: JSON.parse(el.getAttribute(":services") || "{}"),
    mixpanelEvent: el.getAttribute("mixpanel-event") || "",
    design: el.getAttribute("design") || "pdp",
    headerText: el.getAttribute("header-text") || "Complete Your Project!",
    openInNewTab: el.getAttribute(":open-in-new-tab") !== "false",
    componentId: el.getAttribute("component-id") || "jiffy-services-preview"
  };
}

/* v8 ignore start -- mount wrapper tested by E2E, not unit tests */
export const initApp = (selector = "#jiffy-services-preview") => {
  const mountPoint = document.querySelector<HTMLElement>(selector);
  if (!mountPoint || mountPoint.dataset["reactRoot"]) return;

  const props = readPropsFromDom(mountPoint);
  mountPoint.dataset["reactRoot"] = "true";
  mountPoint.innerHTML = "";

  const locale = document.documentElement.lang || "en-US";
  const root = createReactRoot(mountPoint, "Jiffy Services Preview");
  root.render(
    <IntlProvider locale={locale} defaultLocale="en-US" messages={messages}>
      <JiffyServicesPreview {...props} />
    </IntlProvider>
  );
};
/* v8 ignore end */

export default initApp;
